import type { BotStats } from "@investhinks/api-client";
import type { TFunction } from "i18next";
import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

import { LegalFooter } from "../../../../../components/legal";

interface PerformanceSidebarProps {
  stats?: BotStats;
  symbol?: string;
  t: TFunction;
}

const PerformanceSidebar: React.FC<PerformanceSidebarProps> = ({ stats, symbol, t }) => {
  return (
    <Card className="mb-2 card-hover">
      <CardHeader className="py-2 bg-transparent">
        <h6 className="mb-0 text-uppercase text-muted" style={{ fontSize: "0.7rem" }}>
          <i className="fas fa-chart-line mr-2" />
          {t("sidebar.performance")}
        </h6>
      </CardHeader>
      <CardBody className="pt-0 pb-2">
        <div className="d-flex justify-content-between align-items-center py-1 stat-row border-bottom">
          <small className="text-muted">{t("sidebar.profit")}</small>
          <span
            className={`font-weight-bold ${(stats?.absolute_profit ?? 0) < 0 ? "metric-negative" : "metric-positive"}`}
          >
            {(stats?.absolute_profit ?? 0) < 0 ? "-" : "+"}
            {Math.abs(stats?.absolute_profit ?? 0).toFixed(2)} {symbol}
            <small className="ml-1">({stats?.profit_percentage ?? "---"}%)</small>
          </span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1 stat-row border-bottom">
          <small className="text-muted">{t("sidebar.balance")}</small>
          <span className="font-weight-bold">
            {stats?.balance?.toFixed(2) || "---"} {symbol}
          </span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1 stat-row border-bottom">
          <small className="text-muted">{t("sidebar.equity")}</small>
          <span className="font-weight-bold">
            {stats?.equity?.toFixed(2) || "---"} {symbol}
          </span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1 stat-row">
          <small className="text-muted">{t("sidebar.drawdown")}</small>
          <span
            className={`font-weight-bold ${
              (stats?.drawdown || 0) > 30 ? "metric-negative" : (stats?.drawdown || 0) > 15 ? "metric-warning" : ""
            }`}
          >
            {(stats?.drawdown || 0).toFixed(2)}%
          </span>
        </div>
        <LegalFooter type="broker" />
      </CardBody>
    </Card>
  );
};

export default PerformanceSidebar;
